module.exports = __webpack_public_path__ + "static/media/IconDAI.be0d3431.svg";